import { colorHexMap } from "../../../CommonFunctions";
import "./OptionChooser.css";

interface ColorPickerProps {
  colors: Record<string, string>;
  setSelectedColor: (color: string) => void;
  selectedColor?: string;
  setSku: (sku: string) => void;
}

const ColorPicker = ({
  colors,
  setSelectedColor,
  selectedColor,
  setSku,
}: ColorPickerProps) => {
  return (
    <div>
      <label className="store-front-label">Choose a color:</label>
      <div className="store-front-options">
        {Object.entries(colors).map(([sku, colorName]) => (
          <div className="store-front-option-container" key={sku}>
            <button
              className={`store-front-color-option ${
                selectedColor === colorName ? "selected" : ""
              }`}
              style={{ backgroundColor: colorHexMap[colorName] || "#ccc" }}
              onClick={() => {
                setSelectedColor(colorName);
                setSku(sku);
              }}
            />
            <div className="store-front-color-name">{colorName}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ColorPicker;
